import { render, staticRenderFns } from "./ModelClientArea.vue?vue&type=template&id=a86fb680&"
import script from "./ModelClientArea.vue?vue&type=script&lang=js&"
export * from "./ModelClientArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports